import { SearchBox } from "./SearchBox";
const HeroSection = () => {
  return <>
      <div className='sticky top-0 z-[11] -mb-[388px] mt-[308px] h-0'>
        <SearchBox data-sentry-element="SearchBox" data-sentry-source-file="HeroSection.tsx" />
      </div>
      <section className='relative h-[680px] px-4 pb-10 pt-20' id='hero'>
        <img src='/assets/images/travel-agent/hero-bg.png' alt='hero banner' className='absolute inset-0 h-full w-full object-cover' fetchPriority='high' loading='eager' />
        <div className='absolute inset-0 bg-[#1e4c8426]' />
        <div className='absolute inset-0 bg-black-900/30' />

        <div className='relative flex min-h-[308px] flex-col items-center justify-end'>
          <h1 className='mb-4 text-center font-wasgaten text-[40px] font-normal leading-[1.1] tracking-tight text-white md:text-[60px] md:leading-[1.3]'>
            Premium Vacation Properties
            <br />
            Built for Travel Advisors
          </h1>
        </div>
      </section>
    </>;
};
export default HeroSection;